// removed by extract-text-webpack-plugin
module.exports = {"color":"color-24d75","globalPageTitle":"globalPageTitle-1gW0e color-24d75","pageTitle":"pageTitle-1gYKf color-24d75"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/title/title/style.less
 ** module id = 123
 ** module chunks = 0
 **/